const widgetWidths = {
  sm: 4,
  md: 8,
  lg: 12
};

const calculateLayout = layout => {
  let widgetLayout = layout;
  widgetLayout.sm = layout.lg.map(widget => {
    return {
      ...widget,
      minW: widgetWidths.sm,
      w: widgetWidths.sm
    };
  });
  widgetLayout.md = layout.lg.map(widget => {
    return {
      ...widget,
      w: Math.min(widget.minW, widget.w)
    };
  });
  return widgetLayout;
};

const getWidgetHeight = (
  widget,
  widgetContentHeight,
  widgetRowHeight,
  widgetMargin
) => {
  if (widgetContentHeight) {
    const widgetHeight = Math.ceil(
      (widgetContentHeight - widgetRowHeight) /
        (widgetRowHeight + widgetMargin) +
        1
    );
    return widget.layout.maxH
      ? Math.min(widget.layout.maxH, widgetHeight)
      : widgetHeight;
  } else {
    return widget.layout.minH;
  }
};

export default class {
  static getInitialWidgetLayout = (
    widgets,
    widgetContentHeights,
    widgetRowHeight,
    widgetMargin
  ) => {
    if (Array.isArray(widgets)) {
      const widgetsDisplayed = widgets.filter(widget => widget.added);
      const widgetLayout = {
        lg: widgetsDisplayed.map(widget => {
          const { layout, ...widgetProps } = widget;
          return {
            ...layout,
            ...widgetProps,
            i: widget.key,
            h: getWidgetHeight(
              widget,
              widgetContentHeights ? widgetContentHeights[widget.key] : null,
              widgetRowHeight,
              widgetMargin
            )
          };
        })
      };
      return calculateLayout(widgetLayout);
    } else {
      return null;
    }
  };
}
